export const environment = {
  API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT,
  IMAGE_ENDPOINT: process.env.REACT_APP_IMAGE_ENDPOINT,
};
